import React, { useState, useRef, useMemo, useEffect } from "react";
import Dialog from "../../dialog/ImgDialog";
import vactor from "../../../assets/svg/OBJECTS.svg";
import PendingVactor from "../../../assets/svg/pending.svg";
import WelcomeMsg from "./WelcomeMsg";
import VerficationMsg from "./VerficationMsg";
import "../../dialog/imgStyle.css";
import { USER_DETAILS } from "../../layout/Layout";
import { useAtom } from "jotai";

function WelcomeDialog() {
  const [open, setOpen] = useState([false]);
  const [prefill, setPrefill] = useState(false);
  const [userDetails] = useAtom(USER_DETAILS);
  const status = userDetails?.data?.user_details?.vendor_status;
  const fileValue = userDetails?.data?.user_details?.file;
  const rejectedReason = userDetails?.data?.user_details?.reject_reason;
  const [step, setStep] = useState(1);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const inputRef = useRef(null);
  const [file, setFile] = useState(null);

  const handleFile = (e) => {
    const res = e.target.files[0];
    setFile(res);
  };
  const handleRemoveFile = () => {
    setFile(null);
    setPrefill(false);
  };

  const handleStep = () => {
    if (status === "PENDING") {
      if (fileValue) return 2;
      else return 1;
    } else if (status && status === "REJECTED") return 3;
  };

  useEffect(() => {
    setStep(handleStep());
  }, [status, fileValue]);

  function getForm() {
    switch (step) {
      case 1:
        return <WelcomeMsg setStep={setStep} handleClose={handleClose} />;

      case 2:
        return (
          <VerficationMsg
            setStep={setStep}
            status="Pending"
            handleClose={handleClose}
            rejectedReason={rejectedReason}
          />
        );

      case 3:
        return (
          <VerficationMsg
            setStep={setStep}
            status="Rejected"
            handleClose={handleClose}
            rejectedReason={rejectedReason}
          />
        );
    }
  }

  function fetchImg(step) {
    return step === 1 ? vactor : step < 4 && PendingVactor;
  }

  return (
    <div>
      <div>
        <Dialog
          visible={open}
          //   title={"Enter your amount"}
          handleCloseDialog={handleClose}
          // actionsPannel={DialogActions("bg-green")}
          size={"w-2/7"}
          color={"bg-green"}
        >
          <div
            className="w-[500px] scrollbar-hide"
            style={{ maxHeight: "90vh" }}
          >
            <div className="bg-[#DCE7FF] flex justify-center items-center scrollbar-hide">
              <img
                width="270px"
                src={fetchImg(step)}
                className="scrollbar-hide"
              />
            </div>
            <div className="mt-2">{getForm()}</div>
          </div>
        </Dialog>
      </div>
    </div>
  );
}

export default WelcomeDialog;
